import React from 'react';
import styled from 'styled-components';
import { Router } from 'react-router-dom';
import { Box } from '@openfin/ui-library';
import { MemoryHistory } from 'history';
import { connect, Provider } from 'react-redux';
import { Store as PreduxStore } from 'redux';

import { Header, HeaderProps } from '../../components/Header/Header';
import { RootState } from '../../../store/State';
import { ServiceStore } from '../../../store/ServiceStore';
import { getApplicationTitle, getStreamTitle } from '../../utils/SourceInfo';

import { FrameBody } from './FrameBody';
import { GlobalProviderStyles } from '../../styles/GlobalProviderStyles';

interface FrameInfo {
  id: string;
  isStream: boolean;
}

export interface FrameAppProps extends FrameInfo {
  onClose: () => void;
  store: ServiceStore;
  history: MemoryHistory<unknown>;
  /**
   * Callback invoked when the frame has rendered.
   */
  onReady?: () => void;
}

export const FrameApp: React.FC<FrameAppProps> = (props) => {
  const { id, isStream, history, onClose, store, onReady } = props;

  const title = isStream
    ? getStreamTitle(store.state.streams, id)
    : getApplicationTitle(id, store.state.applications);

  const appIcon = !isStream ? store.state.applications.get(id)?.iconUrl : undefined;

  React.useLayoutEffect(() => {
    onReady?.();
  }, []);

  return (
    <Provider store={(store as unknown) as PreduxStore}>
      <GlobalProviderStyles />
      <Router history={history}>
        <ContainerElement flexDirection="column">
          <ConnectedHeader
            icon={appIcon}
            title={title}
            onClose={onClose}
            id={id}
            isStream={isStream}
            draggable
          />
          <FrameBody id={id} isStream={isStream} />
        </ContainerElement>
      </Router>
    </Provider>
  );
};

const ContainerElement = styled(Box)`
  background: ${({ theme }) => theme.palette.background2};
  height: 100vh;
  width: 100%;
  border: 1px solid ${({ theme }) => theme.palette.background4};
`;

const HeaderWrapper: React.FC<HeaderProps & ReturnType<typeof mapHeaderState>> = (props) => {
  return <Header {...props} />;
};

const mapHeaderState = (state: RootState, ownProps: HeaderProps & FrameInfo) => ({
  badgeCount: Object.values(
    (ownProps.isStream
      ? state.sortedNotifications.byStream[ownProps.id]
      : state.sortedNotifications.byApplication[ownProps.id]) ?? {}
  ).length,
});

const ConnectedHeader = connect(mapHeaderState)(HeaderWrapper);
